<script lang="ts" setup>
import { keys } from './injection-keys'
import * as clientSideStored from './util/client-side-stored'
import { scrollTo } from './util/helpers'

const stepsStore = useStepsStore()
const lifecycleStore = useLifecycleStore()
const requestMetaStore = useRequestMetaStore()
const aggregateStepsStore = useAggregateStepsStore()

debouncedWatch(
  () => aggregateStepsStore.storableState,
  storableState => {
    clientSideStored.set(storableState, requestMetaStore.uuid)
  },
  { debounce: 500, deep: true },
)

stepsStore.onAttemptContinue(prevent => {
  const isCurrentStepValid = stepsStore.currentStep.meta.step.store.isValid
  const previousStepsAreValid = stepsStore.previousSteps.every(step => step.meta.step.store.isValid)

  if (isCurrentStepValid && previousStepsAreValid) return

  prevent()
  scrollTo()
})

provide(
  keys.disabled,
  computed(() => lifecycleStore.submitting),
)

function onReset() {
  clientSideStored.clear(requestMetaStore.uuid)
  window.location.reload()
}
</script>

<template>
  <div
    class="ownbit-configurator bg-grey-50 py-4 sm:py-6 md:py-8 xl:[--container-padding:0px] xl:[--container-width:1312px]"
  >
    <div class="mx-auto w-[var(--container-width)] px-[var(--container-padding)]">
      <ValidationMessage
        :message="
          aggregateStepsStore.isValid
            ? ''
            : 'Ihre Angaben sind unvollständig. Bitte überprüfen Sie die markierten Bereiche, um fortzufahren.'
        "
      />
      <Alert :show="requestMetaStore.finalized" theme="success">
        <p class="m-0">
          Diese Anzeige ist bereits
          {{
            aggregateStepsStore.storableState.sichtbarkeit !== 'public' ? '(privat sichtbar)' : ''
          }}
          veröffentlicht.
        </p>
      </Alert>
      <Alert
        :show="requestMetaStore.uuid !== undefined && aggregateStepsStore.isDirty"
        theme="info"
        center-icon
      >
        <div class="flex items-center gap-4">
          <p class="m-0">Sie haben seit dem letzten Speichern Änderungen vorgenommen.</p>
          <ConfirmableButton label="Änderungen verwerfen" class="flex-shrink-0" @confirm="onReset">
            <template #icon>
              <IconReset />
            </template>
          </ConfirmableButton>
        </div>
      </Alert>
      <form autocomplete="off">
        <StepperHeader />
        <div class="pt-12 md:flex md:gap-8 md:pt-16 lg:gap-16 lg:pt-20 xl:gap-24">
          <div class="flex-grow">
            <RouterView />
          </div>
          <AnnouncementColumn />
        </div>
        <StepperFooter />
      </form>
    </div>
  </div>
</template>
